import { render, staticRenderFns } from "./zhuanjia-pro-audit.vue?vue&type=template&id=1b0d5329&scoped=true"
import script from "./zhuanjia-pro-audit.vue?vue&type=script&lang=js"
export * from "./zhuanjia-pro-audit.vue?vue&type=script&lang=js"
import style0 from "./zhuanjia-pro-audit.vue?vue&type=style&index=0&id=1b0d5329&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0d5329",
  null
  
)

export default component.exports